class ProductCard extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLImageElement} */
    this.imageEl = this.querySelector(".product-card__image img:nth-child(1)");
    /** @type {HTMLImageElement} */
    this.hoverImage = this.querySelector(".product-card__image img:nth-child(2)");
    /** @type {string} */
    this.secondaryImageURL = this.hoverImage ? this.hoverImage.src : "";
    /** @type {string} */
    this.secondaryImageSrcset = this.hoverImage ? this.hoverImage.srcset : "";
    /** @type {HTMLButtonElement[]} */
    this.swatchElements = this.querySelectorAll(".product-card__swatch")
    /** @type {HTMLButtonElement} */
    this.firstSwatchEl = this.querySelector(".product-card__swatch.active")
  }

  connectedCallback() {
    this.swatchElements.forEach((swatchEl) => {
      swatchEl.addEventListener("mouseenter", () => {
        this.onSwatchHover("enter", swatchEl);
      });
    });

    // Reset when the pointer leaves the swatch row as a whole, not each swatch.
    // Per-swatch mouseleave meant moving from one swatch to the next reset the
    // image to the card default in between, which read as a flash on every move.
    this.swatchesEl = this.querySelector(".product-card__swatches");
    if (this.swatchesEl) {
      this.swatchesEl.addEventListener("mouseleave", () => {
        this.onSwatchHover("exit");
      });
    }

    // Warm the variant images the first time the card is hovered. Swapping src
    // to an uncached image leaves the frame blank while it loads, which is the
    // other half of the flashing. Deferred to hover rather than done on load so
    // a collection page doesn't fetch every swatch image up front.
    this.addEventListener("mouseenter", () => this.preloadSwatchImages(), { once: true });
  }

  preloadSwatchImages() {
    this.swatchElements.forEach((swatchEl) => {
      const { variantImage } = swatchEl.dataset;
      if (!variantImage) return;
      const img = new Image();
      img.src = variantImage;
    });
  }

  /**
   * 
   * @param {string} type - enter or exit
   * @param {HTMLButtonElement} [swatchEl] - the hovered swatch; omitted on exit
   */
  onSwatchHover(type = "enter", swatchEl) {
    if (!this.hoverImage) return false;
    switch (type) {
      case "enter":
        // Show variant image. Some swatches have no variant image to show, in
        // which case leave the default hover image in place.
        const { variantImage } = swatchEl.dataset;
        if (variantImage) {
          this.hoverImage.src = variantImage;
          this.hoverImage.srcset = variantImage;
        }
        if (this.firstSwatchEl && swatchEl != this.firstSwatchEl) {
          this.firstSwatchEl.classList.remove("active");
        }
        break;
      case "exit": 
       // Show default hover image
       this.hoverImage.src = this.secondaryImageURL;
       this.hoverImage.srcset = this.secondaryImageSrcset;
       if (this.firstSwatchEl) {
         this.firstSwatchEl.classList.add("active");
       }
       break;
      default: 
       return false;
    }
    
  }
}

customElements.define("product-card", ProductCard)